import { css } from "styled-components";

export const btn = () => css`
  outline: none;
  border: none;
  border-radius: 3px;
  padding: 9px 16px;
  font-family: "Noto Sans", Helvetica, Arial, sans-serif;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0;
  cursor: pointer;
`;
